/*eslint-disable*/
import {request} from '@/utils/request/request'
export function ele5(query){
  return request({
      url:'api/tongji/v1/GetDangQianFuHe',
      method:'get',
      params:query
  })
}